import { useState, useEffect } from "react";
import {
  Facebook, Instagram, Youtube, Twitter, Music2, MessageSquare, Globe, Link2, ExternalLink, Loader2,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PLATFORM_META = {
  facebook: { label: "Facebook", Icon: Facebook, color: "#1877F2" },
  instagram: { label: "Instagram", Icon: Instagram, color: "#E4405F" },
  youtube: { label: "YouTube", Icon: Youtube, color: "#FF0000" },
  x: { label: "X / Twitter", Icon: Twitter, color: "#e2e8f0" },
  tiktok: { label: "TikTok", Icon: Music2, color: "#69C9D0" },
  discord: { label: "Discord", Icon: MessageSquare, color: "#5865F2" },
  website: { label: "Website", Icon: Globe, color: "#f59e0b" },
  other: { label: "Other", Icon: Link2, color: "#94a3b8" },
};

export default function LinkTree() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/linktree/public`)
      .then((r) => (r.ok ? r.json() : { links: [] }))
      .then((data) => setLinks(data.links || []))
      .catch(() => setLinks([]))
      .finally(() => setLoading(false));
  }, []);

  const ping = (id) => {
    try {
      fetch(`${BACKEND_URL}/api/linktree/links/${id}/click`, { method: "POST", keepalive: true });
    } catch (e) { /* non-blocking */ }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-950 via-slate-900 to-stone-950 flex flex-col items-center px-4 py-10">
      <div className="w-full max-w-md flex flex-col items-center" data-testid="linktree-page">
        <img
          src="/brothers-logo.png"
          alt="Brothers of the Highway"
          className="w-28 h-28 rounded-full border-2 border-amber-600 shadow-lg shadow-amber-900/40 object-cover bg-stone-900"
          data-testid="linktree-logo"
        />
        <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-white text-center tracking-wide">
          Brothers of the Highway
        </h1>
        <p className="mt-1 text-amber-500/90 text-sm font-medium uppercase tracking-widest">
          Follow us everywhere
        </p>

        <div className="w-full mt-8 space-y-3">
          {loading ? (
            <div className="flex justify-center py-12 text-slate-400">
              <Loader2 className="w-6 h-6 animate-spin" />
            </div>
          ) : links.length === 0 ? (
            <p className="text-center text-slate-500 py-12" data-testid="linktree-empty">
              No links yet — check back soon.
            </p>
          ) : (
            links.map((l) => {
              const meta = PLATFORM_META[l.platform] || PLATFORM_META.other;
              const Icon = meta.Icon;
              return (
                <a
                  key={l.id}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => ping(l.id)}
                  data-testid={`linktree-link-${l.platform}`}
                  className="group flex items-center gap-3 w-full bg-slate-800/70 hover:bg-slate-700/80 border border-slate-700 hover:border-amber-600/60 rounded-2xl px-5 py-4 transition-colors duration-200 shadow-md"
                >
                  <Icon className="w-6 h-6 shrink-0" style={{ color: meta.color }} />
                  <span className="flex-1 text-white font-semibold text-base truncate">{l.label}</span>
                  <ExternalLink className="w-4 h-4 text-slate-500 group-hover:text-amber-500 transition-colors" />
                </a>
              );
            })
          )}
        </div>

        <p className="mt-10 text-slate-600 text-xs">Brothers of the Highway TC — bohhub.com</p>
      </div>
    </div>
  );
}
